import { css } from 'styled-components';
import { COLORS } from '../../../../config/theme';

const style = () => css`
    min-height: 100vh;
    background-color: ${(props: any) => props.theme[COLORS.BACKGROUND]};
`;

export default style();
